<template>
<body class="bg">
<v-container justify-center align-content-end fluid fill-height>
  <v-layout column>
    <v-layout align-end justify-center row>
      <v-flex xs12 sm12 md6 lg6 xl6>
        <v-img src="logo_lalabum.png"></v-img>
      </v-flex>
    </v-layout>

    <v-layout align-center justify-center>
      <v-flex xs12 sm12 md6 lg6 xl6>  
        <v-layout align-center justify-center v-bind="binding">
          <v-flex xs12 sm12 md5 lg5 xl5>  
            <router-link class="menu" to="/login" >
              <v-btn
                large
                class="text-none loginbutton"
                color="#4ba96c"
                dark
              >
                Iniciar Sesión
              </v-btn>   
            </router-link>
          </v-flex>

          <v-flex xs12 sm12 md5 lg5 xl5>  
            <router-link class="menu" to="/signup" >
              <v-btn
                large
                class="text-none registerbutton"
                color="#4ba96c"
                dark
              >
                Regístrate
              </v-btn>
            </router-link>   
          </v-flex>
          
        </v-layout>
      </v-flex>
    </v-layout>

  </v-layout>  
</v-container>
</body>
</template>

<script>
export default {
  
  computed: {
      binding () {
        const binding = {}
          if (this.$vuetify.breakpoint.smAndDown) {
            binding.column = true
          }            
          return binding
      }
    }

}
</script>

<style scoped>
.bg{
    background: url('../assets/fondo_portada.png');
    background-size: cover;
    height: 100%;
}

@media (min-width:750px){
  .loginbutton, .registerbutton{
      border-radius:10px;
      color:white; 
      font-family:Poppins;
      font-weight:500;
      font-size:2vw;
  }
}

@media (max-width:750px){
  .loginbutton, .registerbutton{
      border-radius:10px;
      color:white; 
      font-family:Poppins;
      font-weight:500;
      font-size:5vw;
  }
}

.menu{
  text-decoration:none;
}

</style>

